/*
 * Harmonisierte Mitteilung ueber das gesetzliche Gewaehrleistungsrecht.
 * Gehoert zu snippets/eu-gewaehrleistungs-label.liquid.
 *
 * Liegt als eigene Datei und nicht im Snippet, weil das Snippet mehrfach je
 * Seite gerendert wird und in der Quick-Buy-Variante sogar innerhalb eines
 * <template> - darin wuerde ein <script> nie ausgefuehrt. Ueber die
 * Delegation am document greift der Ausloeser auch in geklontem Markup.
 *
 * Der Ausloeser ist ein <button>, kein Link: Im Theme folgt ein zweiter
 * Mechanismus jedem Linkklick und navigiert die Seite zur Grafik weg, auch
 * wenn das Overlay bereits offen ist. Ohne JavaScript greift stattdessen der
 * <noscript>-Link im Snippet.
 */

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-eu-gewaehrleistung-trigger]');

  if (trigger) {
    var dialog = trigger.parentNode.querySelector('[data-eu-gewaehrleistung-dialog]');

    if (!dialog || typeof dialog.showModal !== 'function') return;

    event.preventDefault();

    var img = dialog.querySelector('img[data-src]');
    if (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    }

    dialog.showModal();
    return;
  }

  var close = event.target.closest('[data-eu-gewaehrleistung-close]');
  if (close) {
    close.closest('dialog').close();
    return;
  }

  // Klick auf den Hintergrund schliesst ebenfalls.
  if (event.target.matches('[data-eu-gewaehrleistung-dialog]')) {
    event.target.close();
  }
});
